import * as React from "react";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import Select from "react-select";
import { v4 as uuid } from "uuid";
import { useBoolean, useId } from "@fluentui/react-hooks";
import {
  FocusZoneTabbableElements,
  PrimaryButton,
  DefaultButton,
  Label,
  Icon,
  Link,
  IconButton,
  mergeStyleSets,
  OverflowSet,
  IButtonStyles,
  IOverflowSetItemProps,
  FocusTrapCallout,
  FontWeights,
  FocusZone,
  Stack,
  TextField,
} from "office-ui-fabric-react";
import { SweetAlerts } from "./Global/SweetAlert";
import ContextService from "../services/ContextService";
import "./Home.css";
import ReactQuill from "react-quill";
import { getCluaseLibraryData, getGeneralData } from "../Utils/CommonFunctions";
import { AddRegular, MoreHorizontal20Regular, Star16Regular } from "@fluentui/react-icons";

let IndexSelected;
let allClauses;
export default function NewClause(props) {
  const [clauseName, setClauseTextName] = React.useState<string>();
  const [question, setQuestion] = React.useState<string>();
  const reactQuillRef = React.useRef(null);
  const [clauseType, setClauseTextType] = React.useState<any>();
  const [systemField, setSystemField] = React.useState<string>();
  const [allClauseType, setAllClaseType] = React.useState([]);
  const [clause, setClause] = React.useState<any>([
    { id:  uuid().toString(), text: 'Clause Title', rted: "", favorite: false },
]);  const [ButtonSaveText, setButtonSaveText] = React.useState<string>("Create");
  const { SweetAlert: Sweetalert} = SweetAlerts("#Sweetaler2");
  const [selectedIndex, setIndex] = React.useState<number>(0);
  React.useEffect(() => {
    IndexSelected = selectedIndex;
  }, [selectedIndex]);

  React.useEffect(() => {
      fetchClauseTypes();
      fetchClauseData();
    }, [])

    async function fetchClauseData() {
        await getCluaseLibraryData().then((data:any)=>{
         allClauses=data?.map((item)=>item.clauseName)
        }).catch((error)=>{
         console.log(error)
        })
       }
  const fieldOptions = [
    { key: "Party A", text: "Party A", value: "Party A", label: "Party A" },
    { key: "Party B", text: "Party B", value: "Party B", label: "Party B" },
    { key: "Party A Name", text: "Party A Name", value: "Party A Name", label: "Party A Name" },
    { key: "Party B Name", text: "Party B Name", value: "Party B Name", label: "Party B Name" },
    {
      key: "Party A Contact Name",
      text: "Party A Contact Name",
      value: "Party A Contact Name",
      label: "Party A Contact Name",
    },
    {
      key: "Party B Primary Contact Name",
      text: "Party B Primary Contact Name",
      value: "Party B Primary Contact Name",
      label: "Party B Primary Contact Name",
    },
    {
      key: "Party A Phone Number",
      text: "Party A Phone Number",
      value: "Party A Phone Number",
      label: "Party A Phone Number",
    },
    { key: "Party A Address", text: "Party A Address", value: "Party A Address", label: "Party A Address" },
    { key: "Party B Address", text: "Party B Address", value: "Party B Address", label: "Party B Address" },
    { key: "Agreement Name", text: "Agreement Name", value: "Agreement Name", label: "Agreement Name" },
    { key: "Agreement Date", text: "Agreement Date", value: "Agreement Date", label: "Agreement Date" },
    { key: "Term Period", text: "Term Period", value: "Term Period", label: "Term Period" },
    { key: "Term End Date", text: "Term End Date", value: "Term End Date", label: "Term End Date" },
    { key: "Amendment Number", text: "Amendment Number", value: "Amendment Number", label: "Amendment Number" },
    {
      key: "Amendment Effective Date",
      text: "Amendment Effective Date",
      value: "Amendment Effective Date",
      label: "Amendment Effective Date",
    },
    {
      key: "Added Clause Heading",
      text: "Added Clause Heading",
      value: "Added Clause Heading",
      label: "Added Clause Heading",
    },
  ];

  const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
  const buttonId = useId("callout-button");
  const styleb = mergeStyleSets({
    callout: {
      width: 320,
      padding: "20px 24px",
    },
    title: {
      marginBottom: 12,
      fontWeight: FontWeights.semilight,
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 20,
    },
  });

  async function fetchClauseTypes() {
     await  getGeneralData().then((data:any)=>{
      const temp = JSON.parse(data.value[0].ClauseType);
      const clauseTypes = temp.map(i=> ({ label: i.Name, value: i.Name, key:i.GUID, Status:i.Status }));
      setAllClaseType(clauseTypes.filter((i) => i.Status === "Active"))
     }).catch((error)=>{
      console.log(error)
     })
    }

  const getCursorPosition = (placeholderValue) => {
    let quillRef = reactQuillRef.current.getEditor();
    quillRef.focus();
    const selection = quillRef.getSelection();
    //console.log(clause[selectedIndex]?.rted)
    quillRef.insertText(selection?.index, " #" + placeholderValue + "#");
    toggleIsCalloutVisible();
  };

  const onRenderOverflowButton = (overflowItems: any[] | undefined): JSX.Element => {
    const buttonStyles: Partial<IButtonStyles> = {
      root: {
        minWidth: 0,
        padding: "0 4px",
        alignSelf: "stretch",
        height: "auto",
      },
      rootHovered:{
        background:'unset'
      }
    };
    return (
      <IconButton
        title="More options"
        styles={buttonStyles}
        menuIconProps={{ iconName: "Moree" }}
        menuProps={{ items: overflowItems! }}
      >
        <MoreHorizontal20Regular/>
      </IconButton>
    );
  };

  const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
    return (
      <Link styles={{ root: { marginRight: 10 } }} onClick={item.onClick}>
        {item.name}
      </Link>
    );
  };

  function onChangeClauseType(selected) {
    if (selected) {
      setClauseTextType(selected.label as string);
    }
  }

  function onChangeSystemFields(selected) {
    if (selected) {
      setSystemField(selected.label as string);
    }
  }

const handleTextChange = (newValue) => {
    setClause(c => {
        if (newValue == "<p><br></p>")
            newValue = ""
        const temp = [...c]
        temp[IndexSelected].rted = newValue
        return temp
    })
}
  const onChangeTitle = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    // console.log(event);
    setClause((c) => {
      const temp = [...c];
      temp[selectedIndex].text = newValue;
      return temp;
    });
  };
  const postClauseData = async () => {
    let flag = false;
    let flag1 = false;
    let flag2 = false;
    let flag3 = false;
    let flag4 = false;

    if (clauseType === "" || clauseType === undefined) {
      flag = true;
      Sweetalert("error", `Please enter clause type`);
    } else if (clauseName === "" || clauseName === undefined || clauseName === null || clauseName.trim() === "") {
      flag1 = true;
      Sweetalert("error", `Please enter clause name`);
    } else if (question === "" || question === undefined || question === null) {
        Sweetalert("error", "Please enter tags");
      flag3 = true;
    } else if (clause[selectedIndex]?.rted === undefined || clause[selectedIndex]?.rted === "") {
        Sweetalert("error", `Clause in mandatory`);
      flag = true;
    } else if (clause.some((item) => item.rted.trim() === "")) {
        Sweetalert("error", "Please fill all clause values");
      flag4 = true;
    }

    for (let i = 0; i < allClauses.length; i++) {
      if (allClauses[i] === clauseName) {
        flag2 = true;
        Sweetalert("error", `Clause name already exist`);
      }
    }

    if (!flag && !flag1 && !flag2 && !flag3 && !flag4) {
      const finalTemplate = {
        Message: JSON.stringify(clause) || "",
        ClauseType: clauseType,
        ClauseName: clauseName,
        Question: question,
        ClauseTitle: clause[selectedIndex]?.text,
      };

      const token = localStorage.getItem("CurrentToken");
      const url = ContextService.GetUrl() + "/_api/web/lists/getbytitle('CLM365ClauseLibrary')/items";
      try {
        const response = await axios.post(url, finalTemplate, {
          headers: {
            Accept: "application/json;odata=nometadata",
            "Content-Type": "application/json;odata=nometadata",
            "odata-version": "",
            Authorization: `Bearer ${token}`,
            "IF-MATCH": "*",
            "X-HTTP-Method": "POST",
          },
        });

        if (response.status === 201 || response.status === 200) {
        Sweetalert("success", `Action completed successfully`);
          setTimeout(() => {
            props.closepanel();
          }, 2000);
        }
      } catch (error) {
        console.error("Error posting data:", error);
        Sweetalert("error", "Something went wrong");
      }
    }
  };

  const deleteClauseType = (alterIndex) => {
    setIndex((c) => (c - 1 < 0 ? 0 : c - 1));

    setTimeout(() => {
      setClause((c) => {
        const temp = [...c];
        temp.splice(alterIndex, 1);
        return temp;
      });
    }, 1000);
  };

  const onFavorite = (alterIndex, action) => {
    let temp;
    setClause((c) => {
      if (action == "set") {
        temp = c.map((curr) => {
          if (curr.id == alterIndex) {
            curr.favorite = true;
          } else {
            curr.favorite = false;
          }
          return curr;
        });
      } else {
        temp = c.map((curr) => ({ ...curr, favorite: false }));
      }
      return temp;
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    const clauseTitle = {
      id: uuid().toString(),
      text: "Alternative Clause ",
      rted: "",
      favorite: false,
    };
    setClause([...clause, clauseTitle]);
    setIndex((c) => c + 1);
    let text;
    text = "Alternative Clause ";
  };

  const _clauseName = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    // console.log(event);
    setClauseTextName(newValue as string);
  };

  const _question = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    // console.log(event);
    setQuestion(newValue as string);
  };

  return (
    <div id="Sweetaler2">
    <div id="NewClauseDiv1">
      <div id="NewClauseDiv2" style={{ gap: "22px" }}>
        <div id="NewClauseDiv3" style={{ width: "100%" }}>
          <Label required>{"Clause Type"}</Label>
          <Select
            maxMenuHeight={200}
            placeholder={"Select Clause Type"}
            options={allClauseType}
            onChange={onChangeClauseType}
            isSearchable={true}
          />
        </div>

        <div id="NewClauseDiv4">
          <div style={{ width: "100%" }}>
            <Label required>{"Clause Name"}</Label>
            <TextField value={clauseName} onChange={_clauseName} style={{ width: "250px" }} placeholder="Eg.Term"/>
          </div>
          <div id="NewClauseDiv5" style={{ width: "100%" }}>
            <Label required>{"Tags"}</Label>
            <TextField value={question} onChange={_question} style={{ width: "620px" }} placeholder="Eg.Keywords"/>
          </div>
        </div>
      </div>

      <div id="NewClauseDiv6"  style={{ marginTop: "1rem" }}>
        <div
          id="NewClauseDiv7"
          style={{ flexDirection: "column", height: "auto", width: "100%" }}
        >
          <div
            id="NewClauseDiv8"
            style={{ height: "auto", maxHeight: "303px", overflowY: "auto" }}
          >
            {clause.map((curr, index) => (
              <div id="NewClauseDiv9" style={{ display: "flex", alignItems: "center" }} key={index}>
                <div id="NewClauseDiv10" className={"gensetng"} style={{ marginBottom: "3px" }}>
                  <div
                    id="NewClauseDiv11"
                    className={"hoverTheAdmin"}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: index == selectedIndex ? '#91bfffdd' : '#c7c7c733',
                    }}
                  >
                    <li id="NewClauseLi35" className={"narrowList"} style={{ width: "100%" }}>
                      <span
                        id="NewClauseSpan30"
                        onClick={() => {
                          setIndex(index);
                        }}
                      >
                        <div
                          id="NewClauseDiv12"
                          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                        >
                          <div id="NewClauseDiv13" className={"labelandicon"} style={{ height: "20px" }}>
                            <span id="NewClauseSpan31">
                              {curr.favorite === true ? (
                                // <Icon
                                //   iconName="favoriteStar"
                                //   styles={{ root: { color: "var(--layoutIconColor)", paddingRight: "5px" } }}
                                // />
                                <Star16Regular style={{ color: 'var(--layoutIconColor)', paddingRight: '5px' }} />
                              ) : (
                                ""
                              )}{" "}
                              {curr.text}
                            </span>
                          </div>
                          <div id="NewClauseDiv14">
                            {clause.length === 1 && (
                              <OverflowSet
                                aria-label="Basic Menu Example"
                                overflowItems={
                                  curr.favorite
                                    ? [
                                        {
                                          key: "item2",
                                          name: "Remove Default",
                                          onClick: () => onFavorite(curr.id, "remove"),
                                        },
                                      ]
                                    : [
                                        {
                                          key: "item2",
                                          name: "Set as Default",
                                          onClick: () => onFavorite(curr.id, "set"),
                                        },
                                      ]
                                }
                                onRenderOverflowButton={onRenderOverflowButton}
                                onRenderItem={onRenderItem}
                                overflowSide={"start"}
                              />
                            )}
                            {clause.length > 1 && (
                              <OverflowSet
                                aria-label="Basic Menu Example"
                                overflowItems={[
                                  { key: "item1", name: "Delete", onClick: () => deleteClauseType(index) },
                                  curr.favorite
                                    ? {
                                        key: "item2",
                                        name: "Remove Default",
                                        onClick: () => onFavorite(curr.id, "remove"),
                                      }
                                    : {
                                        key: "item2",
                                        name: "Set as Default",
                                        onClick: () => onFavorite(curr.id, "set"),
                                      },
                                ]}
                                onRenderOverflowButton={onRenderOverflowButton}
                                onRenderItem={onRenderItem}
                                overflowSide={"start"}
                              />
                            )}
                          </div>
                        </div>
                      </span>
                    </li>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div id="NewClauseDiv15">
            <DefaultButton
              onClick={handleSubmit}
              style={{ width: "100%", alignItems: "center", marginTop: "2px" }}>
              <AddRegular style={{margin:'2px 5px 0px 0px', fontSize:'larger'}}/>
              <span id="NewClauseSpan32"> {"Alternate Clause"}</span>
            </DefaultButton>
          </div>
        </div>

        <div id="NewClauseDiv16" style={{ marginTop: "1.5rem", width: "100%" }}>
          <div id="NewClauseDiv17">
            <Label>{"Clause Title"}</Label>
            <TextField
              placeholder={"Clause Title"}
              onChange={onChangeTitle}
              value={clause[selectedIndex]?.text || ""}
            />
          </div>
          <div>
            <div style={{ display: "flex", marginTop: "10px", justifyContent: "space-between" }}>
              <div>
                <Label style={{ marginTop: "7px" }} required>
                  {"Clause"}
                </Label>
              </div>
              <div>
                <DefaultButton
                  id={buttonId}
                  className="Midd-lab"
                  style={{ marginBottom: "5px" }}
                  onClick={toggleIsCalloutVisible}
                  text={"Insert Fields"}
                />
              </div>
            </div>

            <div id="NewClauseDiv20">
              {isCalloutVisible && (
                <FocusTrapCallout
                  role="alertdialog"
                  className={styleb.callout}
                  gapSpace={0}
                  target={`#${buttonId}`}
                  onDismiss={toggleIsCalloutVisible}
                  setInitialFocus
                  style={{ overflow: "hidden", height: "12rem", backgroundColor: "unset" }}
                >
                  <Label>{"System Fields"}</Label>
                  <Select
                    maxMenuHeight={200}
                    placeholder={"Select Clause Type"}
                    options={fieldOptions.sort((a, b) => a.label.localeCompare(b.label))}
                    onChange={onChangeSystemFields}
                    isSearchable={true}
                  />
                  <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                    <Stack className='StackButtons' gap={8} horizontal>
                      <PrimaryButton onClick={() => getCursorPosition(systemField)}>{"Add"}</PrimaryButton>
                      <DefaultButton onClick={toggleIsCalloutVisible}>{"Cancel"}</DefaultButton>
                    </Stack>
                  </FocusZone>
                </FocusTrapCallout>
              )}
            </div>

            <div id="NewClauseDiv21">
            <ReactQuill
                style={{ width: "100%", height: "150px" }}
                ref={(el) => (reactQuillRef.current = el)}
                theme="snow"
                value={clause[selectedIndex]?.rted || props.Cluase}
                onChange={handleTextChange}
                />

            </div>
          </div>
        </div>
      </div>

      <div id="NewClauseDiv22" style={{ marginTop: "55px", display: "flex", gap: "10px" }}>
        <PrimaryButton onClick={postClauseData}>
          <span id="NewClauseSpan33" style={{ fontWeight: 600 }}>
            {ButtonSaveText}
          </span>
        </PrimaryButton>
        <DefaultButton
          onClick={()=>
            props.setnewClause(false)}>
          {" "}
          {"Cancel"}{" "}
        </DefaultButton>
      </div>
    </div>
    </div>
  );
}
